
'use client';

import { usePathname } from 'next/navigation';
import React from 'react';

export default function ClientLayoutWrapper({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();

  const isHomepage = pathname === '/';
  const bodyClass = isHomepage ? 'front' : 'not-front';

  return <div className={bodyClass}>{children}</div>;
}
